<template>
    <div v-if="ui.features.notes.opened" dusk="ReaderNotes" class="flex flex-1 flex-col overflow-hidden">
        <div class="flex-1 overflow-y-auto overflow-x-hidden">
            <div
                v-if="selectionsIsEmpty"
                role="status"
                aria-live="polite"
                class="flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
            >
                <p class="text-sm opacity-60">
                    {{ localizations[lang].noNotes }}
                </p>
            </div>
            <div
                v-else-if="notesLists.length === 0"
                role="status"
                aria-live="polite"
                class="flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
            >
                <p class="text-sm opacity-60">
                    {{ localizations[lang].noFilterNotesColor }}
                </p>
            </div>
            <HighlightAndNotesText v-else :highlights="notesLists" />
        </div>
        <ExportNotesOrHighlight :highlights="notesLists" @checked-colors="updateCheckedColors" />
    </div>
</template>

<script>
'use strict';

import { mapGetters, mapState } from 'vuex';
import HighlightAndNotesText from '../partials/HighlightAndNotesText.vue';
import ExportNotesOrHighlight from '../partials/ExportNotesOrHighlight.vue';

export default {
    name: 'ReaderNotes',
    components: {
        HighlightAndNotesText,
        ExportNotesOrHighlight,
    },
    data() {
        return {
            checkedColors: [],
        };
    },
    computed: {
        ...mapState(['ui', 'localizations', 'lang', 'selections']),
        ...mapGetters(['highlightColorsCode']),

        notesLists() {
            return this.selections.filter(
                selection => this.checkedColors.includes(selection.color) && selection.hasAnnotation
            );
        },

        selectionsIsEmpty() {
            return this.selections.filter(s => s.hasAnnotation).length === 0;
        },
    },
    mounted() {
        this.checkedColors = this.highlightColorsCode;
    },
    methods: {
        updateCheckedColors(colors) {
            this.checkedColors = [...colors];
        },
    },
};
</script>
